module.exports = __webpack_public_path__ + "img/solution-pc-100.a8b3e17b.png";